module.exports = __webpack_public_path__ + "img/winServ_89x69.ca6e4a86.svg";